/**
 * DiscountsCtrl controller
 */

// controller mixins
DiscountsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * DiscountsCtrl controller
 *
 * @class DiscountsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:DiscountsCtrl
 */
/* @ngInject */
export default function DiscountsCtrl ($scope, $uibModal, Coupon, pckg, inapp) {
  var vm = this
  vm.mixes = [['tabsCtrlMixin', '', 'coupons', 'discount']]

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:DiscountsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  // $scope.loading = true

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:DiscountsCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.network?.id

  // package id
  const networkId = pckg.id

  /**
   * Coupons list
   *
   * @memberof mwApp/packages.controller:DiscountsCtrl
   * @type {models.Coupon[]}
   */
  vm.coupons = []

  // will NEED data
  // vm.coupons = [] // - content
  vm.discounts = [] // - content
  vm.subscriptions = [] // - for sort

  /**
   * Get Channels from backend
   *
   * @memberof mwApp/packages.controller:DiscountsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getCoupons = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    var pObject = tableState.search.predicateObject = tableState.search.predicateObject || {}
    pObject.coupons = true

    Coupon.loadSmart(tableState, { networkId })
      .then(
        data => {
          vm.couponsName = data.content.map(content => content.name)
          vm.coupons = data.content
          vm.coupons.forEach(cp => { cp.networkId = networkId })
          vm.isFound = !!vm.coupons.length

          $scope.loading = false
        }
      )
  }

  /**
   * Create coupon
   *
   * @memberof mwApp/packages.controller:DiscountsCtrl
   * @function
   * @param {models.Coupon} coupon
   */
  vm.addCoupon = vm.editCoupon = function (coupon) {
    var isNew = !coupon
    var initialCoupon = angular.copy(coupon) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/addCoupon.html',
      controller: 'AddCouponCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        coupon: function () {
          return !isNew
            ? coupon._update()
            : (
              new Coupon({
                networkId
              })
            )
        },
        pckg: function () {
          return vm.pckg
        }
      }
    }).result
      .then(
        function close (coupon) {
          if (isNew) {
            vm.coupons.push(coupon)
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialCoupon, coupon) // restore coupon
          }
        }
      )
  }

  /**
   * Mapping coupon type
   *
   * @memberof mwApp/discounts.controller:DiscountsCtrl
   * @param type
   */
  vm.mapType = function (type) {
    if (type === 'PERCENT') return '%'
    return 'Fixed Amount'
  }

  /**
   * Delete coupon
   *
   * @memberof mwApp/discounts.controller:DiscountsCtrl
   * @param {models.Coupon} cn
   */
  vm.deleteCoupon = function (cn) {
    cn._delete().then(() => $scope.$broadcast('refreshTable'))
  }
}
